module.exports = __webpack_public_path__ + "img/dance-school-icon8.ecaa73de.png";